import { useEffect, useMemo, useState } from "react";
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';
import { useOktaAuth } from "@okta/okta-react";
import { getTSPSurveyPartsBySupplier } from '../../services/tps.service';
import { ProgressIndicator } from './ProgressIndicator'
import { TPS_RESPONSE_STATUSES } from '../../utils/surveyLiterals';
import useTpsContext from '../../hooks/useTpsContext'
import { useTranslation } from "react-i18next";

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarFilterButton />
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}


export const PartsTable = ({ campaign, partsSelected, survey }) => {
    const { suppliers, updatePartsArray } = useTpsContext();
    const [data, setData] = useState(undefined);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectionModelCopy, setSelectionModelCopy] = useState([]);
    const { authState } = useOktaAuth();
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            field: 'supplierNumber',
            headerName: t('parts_tbl_column_header_1'),
            width: 120,
        },
        {
            field: 'deerePartNumber',
            headerName: t('parts_tbl_column_header_2'),
            width: 150,
        },
        {
            field: 'deerePartDesc',
            headerName: t('parts_tbl_column_header_3'),
            width: 250,
        },
        {
            field: 'hsCode',
            headerName: t('parts_tbl_column_header_4'),
            width: 100,
        },
        {
            field: 'status',
            headerName: t('parts_tbl_column_header_5'),
            width: 150
        }
    ], [])

    useEffect(() => {
        if (Array.isArray(suppliers) && suppliers.length > 0) {
            getTSPSurveyPartsBySupplier(suppliers, campaign.id, authState.accessToken.accessToken, survey.code)
                .then(response => {
                    if (Array.isArray(response)) {
                        const partsSelectedState = [];
                        if(partsSelected && partsSelected.length > 0){
                            partsSelected.forEach(it => {
                                let current = response.find(ele=> ele.id === it.id);
                                if(current){
                                    partsSelectedState.push(current.id);
                                }
                            });
                        }
                        setSelectionModel([...partsSelectedState]);
                        setSelectionModelCopy([...partsSelectedState]);
                        setData(response);
                    }
                })
                .catch(error => { throw error });
        }
        else {
            setData(undefined)
        }

    }, [authState.accessToken.accessToken, campaign.id, suppliers]);

    const disableRow = (row) => {
        if(!selectionModelCopy.includes(row.id)){
            if ((row.status && row.status.trim().toUpperCase() === TPS_RESPONSE_STATUSES.IN_PROCESS.toUpperCase())
                        || (row.status && row.status.trim().toUpperCase() === TPS_RESPONSE_STATUSES.SUBMITTED.toUpperCase())) {
                return false;
            }
        }
        return true;
    }

    const setDisableRowStyle = (status) => {
        if (status && status.trim().toUpperCase() === TPS_RESPONSE_STATUSES.IN_PROCESS.toUpperCase()) {
            return 'disable-row-submitted-status'
        }
        else if (status && status.trim().toUpperCase() === TPS_RESPONSE_STATUSES.SUBMITTED.toUpperCase()) {
            return 'disable-row-in-progress-status'
        }
        return '';
    }

    const style = {
        height: 400,
        width: "100%",
        '& .disable-row-in-progress-status': {
            color: '#b3b3b3'
        },
        '& .disable-row-submitted-status': {
            color: '#b3b3b3'
        }
    }

    const dTable = <Box sx={style}>
        <DataGrid rows={data} columns={columns}
            rowsPerPageOptions={[data ? data.length : 0]}
            checkboxSelection
            disableSelectionOnClick
            disableColumnMenu
            isRowSelectable={
                (params) => disableRow(params.row)
            }
            getRowClassName={
                (params) => setDisableRowStyle(params.row.status)
            }
            onSelectionModelChange={(ids) => {
                setSelectionModel(ids);
                updatePartsArray([...ids]);
            }}
            components={{
                Toolbar: CustomToolbar,
            }}
            selectionModel={selectionModel}
        />
    </Box>

    return Array.isArray(data) ? dTable : <ProgressIndicator title={t('tps_lbl_waiting_country_message_title')} subtitle={t('tps_lbl_waiting_country_message_subtitle')} />
}

